module.exports = __webpack_public_path__ + "img/ic_twotone_clock.8f8a8fb0.png";